<template>
    <div id="content">
        <div id="technos">
            <img src="@/assets/img/bandeau_haikara_slide01.png" alt="" />
            <img src="@/assets/img/bandeau_haikara_slide02.png" alt="" />
            <img src="@/assets/img/bandeau_haikara_slide03.png" alt="" />
        </div>
    </div>

    <Contact />
</template>

<script>
import Contact from "../components/Contact.vue";
export default {
    name: "Technos",
    data() {
        return {};
    },
    components: {
        Contact,
    },
};
</script>

<style lang="scss" scoped>
#technos {
    position: relative;

    img {
        width: 100%;
        display: block;
    }
}
</style>
